export function normalizeInternalPath<T extends string | undefined>(path: T): T {
  if (typeof path !== 'string') return undefined as T;
  if (path === '/') return '/' as T;

  const lowerPath = path.toLowerCase();
  return lowerPath.replace(/\/$/, '') as T;
}
